import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'react-bootstrap';
import SearchBox from 'components/site/SearchBox';
import Badge from 'components/v2/Badge';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import { useTranslation } from 'react-i18next';

export default function MultiSelectShipment({
  onSelect,
  onRemove,
  selectedItems,
  placeholder,
  className,
}) {
  const { t } = useTranslation();
  const [permActions, setPermActions] = useState([]);
  const [actions, setActions] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setActions(() =>
      permActions.filter(
        (action) => !selectedItems.map((i) => i._id).includes(action._id),
      ),
    );
  }, [selectedItems]);

  const clear = () => {
    setSearchText('');
    setActions([]);
  };

  const handleSearch = (nGram) => {
    const searchTerm = (nGram || '').toLowerCase();
    // API call
    let query = {
      reference: [searchTerm],
      page: 1,
      per_page: 5,
      paginate: false,
      select: 'reference_numbers timeline status shipment_id',
      unconstrain: true,
    };

    ShipmentWebAPIUtils.getShipmentsByReference(
      query,
      (res) => {
        setPermActions(res.entity.items);
        setActions(res.entity.items);
      },
      (res) => {
        console.log('Error', res.body);
      },
    );
  };

  const renderItem = (item) => {
    return (
      <a
        key={item._id}
        id={item._id}
        className="list-group-item"
        style={{ cursor: 'pointer' }}
      >
        <h4 className="list-group-item-heading">
          <Label bsStyle="primary">{item.shipment_id}</Label>{' '}
          <span className="text-sm">{item.shipment_type}</span>
        </h4>
      </a>
    );
  };

  return (
    <div className={className}>
      <SearchBox
        items={actions}
        value={searchText}
        clear={clear}
        clearOnSelect={false}
        search={(nGram) => handleSearch(nGram)}
        placeholder={t(placeholder)}
        onSelect={(value, item, stateValue) => {
          onSelect(value, item, stateValue);
        }}
        renderItem={(item) => renderItem(item)}
        nGramLength={2}
      />
      <div className="flex flex-wrap items-center justify-start mt-2">
        {selectedItems.map((el) => {
          return (
            <div className="mt-2 mr-2" key={el._id}>
              <Badge color="green" withRemove onRemove={() => onRemove(el)}>
                {el.shipment_id}
              </Badge>
            </div>
          );
        })}
      </div>
    </div>
  );
}

MultiSelectShipment.propTypes = {
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
  selectedItems: PropTypes.array,
  placeholder: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

MultiSelectShipment.defaultProps = {
  onSelect: () => {},
  onRemove: () => {},
  selectedItems: [],
  placeholder: 'ENTER_SHIPMENT_REFERENCE',
  className: 'mt-4',
};
